import { Popover, Whisper, Dropdown } from "rsuite";
import IconButton from "elements/IconButton";
import DropdownOptionWithIcon from "components/Menus/DropdownOptionWithIcon";
import DropdownMenuDivider from "components/Menus/DropdownMenuDivider";
import { useRef } from "react";
import Constants from "utils/Constants";

const iconMap = Constants.MAPPING_ICONS;

const ImportOptionsDropdown = ({
  onModeSwitch,
  onDeleteColumn,
  isComplexMappedHeader,
  dynamicValuesAvailable = false,
  usesActions = false,
}) => {
  const whisperRef = useRef();

  const onDelete = () => {
    whisperRef.current.close();
    onDeleteColumn();
  };

  const onSwitch = (mode) => () => {
    whisperRef.current.close();
    onModeSwitch(mode);
  };

  return (
    <Whisper
      trigger="click"
      placement="bottomEnd"
      preventOverflow
      ref={whisperRef}
      speaker={
        <Popover className="sidebar-popover" full>
          <Dropdown.Menu style={{ maxWidth: 250 }}>
            <h5 className="px-2 pt-2 text-dark">
              <i className="mdi mdi-cog pr-2"></i>Field Mapping Options
            </h5>
            <DropdownMenuDivider />
            <DropdownOptionWithIcon
              name={
                isComplexMappedHeader
                  ? "Use Data From File"
                  : "Use A Data Identifier"
              }
              icon={iconMap["Identifier"]}
              onClick={onSwitch("Identifier")}
            />

            {!isComplexMappedHeader && (
              <DropdownOptionWithIcon
                name="Use A Value"
                icon={iconMap["Value"]}
                onClick={onSwitch("Value")}
              />
            )}
            {usesActions && (
              <DropdownOptionWithIcon
                name="Use An Action"
                icon={iconMap["Action"]}
                onClick={onSwitch("Action")}
              />
            )}
            {dynamicValuesAvailable && (
              <DropdownOptionWithIcon
                name="Use Dynamic Value"
                icon={iconMap["Dynamic"]}
                onClick={onSwitch("Dynamic")}
              />
            )}
            <DropdownMenuDivider />
            <DropdownOptionWithIcon
              name="Remove Field"
              icon="mdi mdi-delete"
              onClick={onDelete}
            />
          </Dropdown.Menu>
        </Popover>
      }
    >
      <div>
        <IconButton
          icon="dots-horizontal"
          outline={typeof mappedHeader !== "object"}
          className="mr-0"
        />
      </div>
    </Whisper>
  );
};

export default ImportOptionsDropdown;
